import { render, staticRenderFns } from "./ReportTypeDescription.vue?vue&type=template&id=71943938&"
import script from "./ReportTypeDescription.vue?vue&type=script&lang=js&"
export * from "./ReportTypeDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports